import { render, staticRenderFns } from "./AttentionMessage.vue?vue&type=template&id=e36f405c"
import script from "./AttentionMessage.vue?vue&type=script&lang=js"
export * from "./AttentionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports